export function formatInsertError(err: unknown): string {
  const msg = err instanceof Error ? err.message : String(err);
  if (msg.includes("Office error 5001")) {
    return "Select the boxes on the slide, then Insert.";
  }
  return msg.startsWith("Insert failed:") ? msg : `Insert failed: ${msg}`;
}
